<script>
import { formatPrice } from '@/libraries/Helpers'
import {
  order,
  currency,
  totalPayNowPrice,
  totalPrice,
  useYourOwnAmountServiceAlreadyPaid,
  useYourOwnAmountServicePrice,
  isUseYourOwnAmountService,
} from '@/stores/Order'

export default {
  setup() {
    return {
      formatPrice,
      currency,
      totalPrice,
      totalPayNowPrice,
      order,
      useYourOwnAmountServiceAlreadyPaid,
      useYourOwnAmountServicePrice,
      isUseYourOwnAmountService,
    }
  },
}
</script>

<template>
  <div class="flex flex-col items-end">
    <div
      class="flex justify-start items-center text-blue-900 font-medium text-right"
      v-if="totalPayNowPrice"
    >
      <div class="text-6 uppercase -mt-5px mr-4">
        {{ __('title_pay_now_price') }}
      </div>
      <div class="text-12 min-w-38">
        {{ currency }} {{ formatPrice(totalPayNowPrice) }}
      </div>
    </div>

    <div
      class="flex justify-start items-center text-blue-900 font-medium text-right"
      v-if="order.total_paid"
    >
      <div class="text-6 uppercase -mt-5px mr-4">
        {{ __('title_paid_price') }}
      </div>
      <div class="text-12 min-w-38">
        {{ currency }} {{ formatPrice(order.total_paid) }}
      </div>
    </div>

    <div
      class="flex justify-start items-center text-blue-900 font-medium text-right"
    >
      <div class="text-6 uppercase mr-4 -mt-5px">
        {{ __('title_total_price') }}
      </div>
      <div class="text-12 min-w-38">
        {{ currency }} {{ formatPrice(totalPrice) }}
      </div>
    </div>
  </div>
</template>
